import { PlatformLocation } from '@angular/common';
import { Component } from '@angular/core';
import { ColorSchemeService } from '@fantaz/shared/services/color-scheme';
import { ShareService } from '@fantaz/shared/share';
import { Store } from '@ngrx/store';

@Component({
  selector: 'fz-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {
  constructor(
    private store: Store,
    private platformLocation: PlatformLocation,
    private shareService: ShareService,
    private readonly colorSchemeService: ColorSchemeService,
  ) {
    this.colorSchemeService.init();
  }

  get colorScheme() {
    return this.colorSchemeService.get();
  }
}
